import React from "react";
import "../../intro.css";
// import Doc from "../../assets/doc.svg";

const Intro = () => {
    return (
        // <div className="all">
        //     <div className="intro">
        //         {/* Intro */}
        //         <div className="head">
        //             <p>We Call Them <span>Folio</span></p>
        //         </div>
        //         <p>For us Folio is a pdf file which has simple and concise written content, that would help the reader to gain knowledge quickly.
        //         </p>
        //         <p>An informative document on a certain topic, notes of a subject or any information in textual form is a Folio.
        //         </p>

        //     </div>
        //     <img className="doc" src={Doc} alt="doc" />
        // </div>

        <>

            <section class="showcase">
                <div class="container-fluid p-0">
                    <div class="row no-gutters">
                        <div class="col-lg-6 order-lg-2 order-2 text-white showcase-img img-1 d-flex justify-content-center align-self-center"></div>
                        <div class="col-lg-6 order-lg-1 order-1 my-auto showcase-text intro">
                            <div className="head">
                                <p>We Call Them <span>Folio</span></p>
                            </div>
                            <p>For us Folio is a pdf file which has simple and concise written content, that would help the reader to gain knowledge quickly.
                            </p>
                            <p>An informative document on a certain topic, notes of a subject or any information in textual form is a Folio.
                            </p>

                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default Intro;
